import { Component, OnInit, AfterViewInit, OnDestroy } from "@angular/core";
import { CclDrawerService, CclNavbarFooterService, CclMessageService } from "certain-common-library";
import { SharedService } from "../../../../../modules/shared/services/shared.service";
import { FlashMessagesService } from "angular2-flash-messages";
import { Subscription } from "rxjs";
import { cloneDeep } from "lodash";
import { CatalogService } from "../../../../../modules/shared/services/catalog.service";
import { UnsavedChangesDeactivate } from "../../../can-deactivate";

@Component({
    selector: "app-tabs-page",
    templateUrl: "./tabs-page.view.html",
    styleUrls: []
})
export class TabsPageView extends UnsavedChangesDeactivate implements AfterViewInit, OnInit, OnDestroy {
    subscription: Subscription;
    tabConfigObj: any;
    tabConfig: any;
    tabStyles: any = [
        {
            label: "Tab",
            code: "tab"
        },
        {
            label: "Underline",
            code: "underline"
        }
    ];

    tabBasedOn: any = [
        {
            label: "Speaker Type",
            code: "speakerType"
        }
    ];

    tabData: any = [
        {
            label: "Event Days",
            code: "eventDays"
        },
        {
            label: "Session Days",
            code: "sessionDays"
        }
    ];

    today: any = new Date();
    constructor(
        public sharedService: SharedService,
        private drawerService: CclDrawerService,
        private navbarFooterService: CclNavbarFooterService,
        private messageService: CclMessageService,
        private _flashMessagesService: FlashMessagesService,
        private catalogService: CatalogService
    ) {
        super(sharedService);
        this.sharedService.currentLayoutSection = "tabs";
        this.subscription = this.messageService.getMessage().subscribe((message) => this.saveTabConfig(message));

        var tabBasedOn = this.tabBasedOn;
        this.sharedService.speakerEnumCustomFields.forEach((cf) => {
            tabBasedOn.push({
                code: cf.id,
                label: cf.name
            });
        });
    }

    ngOnInit() {
        this.drawerService.closeMessage = null;
        this.tabConfig = cloneDeep(this.sharedService.tabConfig);
        this.sharedService.currentLayoutSection = "tabs";
        this.tabConfigObj = this.sharedService.configs[this.sharedService.configTypes.TAB_CONFIG];
        if (this.tabConfigObj == null || this.tabConfigObj.id == null) {
            this.tabConfigObj = {
                id: null,
                sessionCatalogSetup: {
                    id: this.sharedService.setup.id
                },
                config: null,
                configType: this.sharedService.configTypes.TAB_CONFIG
            };
        } else {
            this.tabConfig = JSON.parse(this.tabConfigObj.config);
        }
        // For checking unsaved data
        this.sharedService.originalData = cloneDeep(this.tabConfig);
        this.sharedService.changedData = this.tabConfig;
    }

    ngAfterViewInit(): void {
        if (this.navbarFooterService.navbar != null && this.navbarFooterService.navbar.rightNavbarItems != null) {
            if (
                this.sharedService.catalogLayoutConfig.vipUnit == "card" ||
                this.sharedService.catalogLayoutConfig.vipUnit == "list"
            ) {
                this.navbarFooterService.navbar.rightNavbarItems[0].label =
                    "NEXT STEP: Define Featured Speaker";
            } else {
                this.navbarFooterService.navbar.rightNavbarItems[0].label = "NEXT STEP: Define General Speaker";
            }
            this.navbarFooterService.navbar.rightNavbarItems[1].message = "save-tabs";
            this.navbarFooterService.navbar.rightNavbarItems[2].message = "save-next-tabs";
        }
        this.messageService.sendMessage("update-publish-button");
    }

    ngOnDestroy(): void {
        this.sharedService.unsubscribeHelper(this.subscription);
    }

    saveTabConfig(message) {
        if (message.text == "save-tabs" || message.text == "save-next-tabs") {
            this.tabConfigObj.config = JSON.stringify(this.tabConfig);
            this.catalogService.saveSetupConfig(this.tabConfigObj).subscribe((resp) => {
                this.sharedService.createCss(this.catalogService);
                // For checking unsaved data
                this.sharedService.originalData = cloneDeep(this.tabConfig);
                this.sharedService.changedData = this.tabConfig;

                this.tabConfigObj = resp.body["sessionCatalogSetupConfigDTO"];
                this.sharedService.configs[this.sharedService.configTypes.TAB_CONFIG] = this.tabConfigObj;
                this._flashMessagesService.show("Tabs saved successfully.", {
                    cssClass: "alert-success"
                });
                if (message.text == "save-next-tabs") {
                    if (
                        this.sharedService.catalogLayoutConfig.vipUnit == "card" ||
                        this.sharedService.catalogLayoutConfig.vipUnit == "list"
                    ) {
                        this.sharedService.currentLayoutSection = "highlighted-speaker";
                        this.sharedService.catalogNavigateHelper("admin", "catalog/layout/highlighted-speaker");
                    } else {
                        this.sharedService.currentLayoutSection = "general-speaker";
                        this.sharedService.catalogNavigateHelper("admin", "catalog/layout/general-speaker");
                    }
                }
            });
        } else if (message.text == "apply-tab-config") {
            this.tabConfig = cloneDeep(this.sharedService.tabsConfig);
            // For checking unsaved data
            this.sharedService.changedData = this.tabConfig;

            this.drawerService.hideDrawer();
        }
    }

    toggleTabsEnable(e) {
        this.tabConfig.isTabsEnabled = !this.tabConfig.isTabsEnabled;
    }

    openConfigDrawer(item) {
        this.sharedService.currentDrawer = {
            title: "Edit Tabs",
            navLinks: null,
            saveMessage: "apply-tab-config"
        };
        this.drawerService.toggleDrawer("small");
        let url = "";
        if (item == "tab") {
            this.sharedService.tabsConfig = cloneDeep(this.tabConfig);
            url = "config-drawer/tab-config";
        }
        this.sharedService.navigateToOutlet("drawer", url);
    }
}
